import React, { useEffect, useState } from "react";
import { BiCopy, BiListUl } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";

const OpenDeployment = () => {
    const user_id = sessionStorage.getItem("user_id");
    const { project_id, deployment_id, link_page } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false);
    const [copied, setCopied] = useState(false)
    const [playboxName, setplayboxName] = useState(null)
    const [logs, setLogs] = useState("")
    const [reload, setReload] = useState(false)

    const changePage = (page) => {
        navigate(`/project_panel/${project_id}/deployments/${deployment_id}/${page}`)
    }

    const goBack = () => {
        navigate(`/project_panel/${project_id}/deployments`)
    }

    const fetchRecords = async () => {
        setLoading(true)
        setReload(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_specific_deployment", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, deployment_id }),
            });

            if (response.ok) {
                const result = await response.json();
                const data = result.deployment || {};
                setplayboxName(data.deployment_name)
                setLogs(data.logs)
                setError(false);
                setLoading(false);
                return data.status;
            } else {
                setError(true);
                setLoading(false);
            }
            setReload(false)
        } catch (err) {
            setReload(false)
            setError(true);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchRecords()
        } else {
            setError(true);
            setLoading(false);
        }
    }, []);



    const handleCopyClick = () => {
        navigator.clipboard.writeText(deployment_id);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div>
            <div className="new_section_main_view">
                <p className="new_section_main_view_title fade-in">
                    <i className="fa-solid fa-chevron-left" onClick={goBack}></i> <span className={`${playboxName ? "new_section_main_view_title_span" : "new_section_main_view_title_span_loading"}`}>{playboxName}</span>
                    <span className={`${deployment_id ? "new_section_main_view_title_db_id" : "new_section_main_view_title_db_id_loading"}`}>
                        {deployment_id}
                        {deployment_id && (
                            <i onClick={handleCopyClick}>
                                {copied ? (
                                    <i className="fa-solid fa-check"></i>
                                ) : (
                                    <BiCopy />
                                )}
                            </i>
                        )}
                    </span>
                </p>
                <p className="new_section_main_view_subtitle fade-in">
                    All the resources you need in a single page.
                </p>
                {!loading && (
                    <></>
                )}

                <div className="open_db_main_view">
                    <div className="open_db_main_navbar fade-in">
                        <div className="open_db_main_navbar_cont">
                            {/* <button className={`open_db_main_btn ${link_page === "performance" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("performance")}><IoMdTrendingUp /> Performance</button> */}
                            <button className={`open_db_main_btn ${link_page === "logs" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("logs")}><BiListUl /> Deployment logs</button>
                            {/* <button className={`open_db_main_btn ${link_page === "playbox-pricing" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("playbox-pricing")}><TbZoomMoney /> Usage</button> */}
                        </div>
                        <div className="open_db_main_navbar_cont">
                            <button className="open_db_main_btn" onClick={fetchRecords}><i className="fa-solid fa-rotate"></i></button>
                        </div>
                    </div>
                    {loading ? (
                        <div className="loading_playbox_cont fade-in">

                        </div>
                    ) : (
                        <div className="deployment_logs_container fade-in">
                            {logs && (
                                <div className="fade-in" dangerouslySetInnerHTML={{ __html: logs }} />
                            )}
                        </div>
                    )}

                </div>
            </div>
            {/* 
            <InfoModal
                show={openInfo}
                handleClose={() => setOpenInfo(false)}
                records={records}
            /> */}
        </div>
    )
}

export default OpenDeployment